import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';
import { FuseConfirmationDialogComponent } from '@fuse/services/confirmation/dialog/dialog.component';
import { merge } from 'lodash-es';
import { ConfirmationConfig } from './dialog-email/confirmation-email.types';
import { DialogEmailComponent } from './dialog-email/dialog-email.component';
import { DialogDescriptionComponent } from './dialog-description/dialog-description.component';
import { ConfirmationServidorConfig } from './dialog-servidor/confirmation-servidor.types';
import { DialogServidorComponent } from './dialog-servidor/dialog-servidor.component';

@Injectable({ providedIn: 'root' })
export class FuseConfirmationService {
  private _matDialog: MatDialog = inject(MatDialog);
  private _defaultConfig: FuseConfirmationConfig = {
    title: 'Confirmar Ação',
    message: 'Você tem certeza que deseja confirmar esta ação?',
    icon: {
      show: true,
      name: 'heroicons_outline:exclamation-triangle',
      color: 'warn',
    },
    actions: {
      confirm: {
        show: true,
        label: 'Confirmar',
        color: 'warn',
      },
      cancel: {
        show: true,
        label: 'Cancelar',
      },
    },
    dismissible: false,
  };

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  open(
    config: FuseConfirmationConfig = {}
  ): MatDialogRef<FuseConfirmationDialogComponent> {
    // Merge the user config with the default config
    const userConfig = merge({}, this._defaultConfig, config);

    // Open the dialog
    return this._matDialog.open(FuseConfirmationDialogComponent, {
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      data: userConfig,
      panelClass: 'fuse-confirmation-dialog-panel',
    });
  }

  openEmail(
    config: ConfirmationConfig = {}
  ): MatDialogRef<DialogEmailComponent> {
    // Merge the user config with the default config
    const userConfig = merge({}, this._defaultConfig, config);

    // Open the dialog
    return this._matDialog.open(DialogEmailComponent, {
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      data: userConfig,
      panelClass: "fuse-confirmation-dialog-panel",
    });
  }

  openDescricao(
    config: ConfirmationConfig = {}
  ): MatDialogRef<DialogDescriptionComponent> {
    // Merge the user config with the default config
    const userConfig = merge({}, this._defaultConfig, config);

    // Open the dialog
    return this._matDialog.open(DialogDescriptionComponent, {
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      data: userConfig,
      panelClass: "fuse-confirmation-dialog-panel",
    });
  }

  openServidor(
    config: ConfirmationServidorConfig = {}
  ): MatDialogRef<DialogServidorComponent> {
    // Merge the user config with the default config
    const userConfig = merge({}, this._defaultConfig, config);

    // Open the dialog
    return this._matDialog.open(DialogServidorComponent, {
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      data: userConfig,
      panelClass: "fuse-confirmation-dialog-panel",
    });
  }
}
